<div class="py-4 container-fluid compensation-summary-page">
  <h4 class="mb-4 compensation-summary-title">
    การจัดการคำขอสอนชดเชย - สรุปค่าสอนเกินภาระงาน
  </h4>

  <div class="compensation-summary-card">
    <div class="compensation-summary-card-body">
      <div class="compensation-summary-toolbar" [formGroup]="form">
        <div class="compensation-summary-filter">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="compensation-summary-select"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="compensation-summary-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="year"
            [options]="yearOptions"
            [searchable]="false"
            [clearable]="false"
            inputClass="compensation-summary-select"
            classes="mb-0"
          ></app-select>
        </div>
      </div>

      <div class="compensation-summary-state" *ngIf="isLoading()">
        กำลังโหลดข้อมูลสรุปค่าสอนเกินภาระงาน...
      </div>

      <div class="compensation-summary-state compensation-summary-state-error" *ngIf="!isLoading() && hasLoadError()">
        ไม่สามารถโหลดข้อมูลสรุปค่าสอนเกินภาระงานได้ กรุณาลองใหม่อีกครั้ง
      </div>

      <div class="compensation-summary-tabs" role="tablist" aria-label="สรุปค่าสอนเกินภาระงาน">
        <button
          type="button"
          id="compensation-summary-tab-requests"
          class="compensation-summary-tab"
          role="tab"
          aria-controls="compensation-summary-panel-requests"
          [attr.aria-selected]="activeTab() === 'requests'"
          [class.active]="activeTab() === 'requests'"
          (click)="onTabChange('requests')"
        >
          สรุปการรับรองคำขอชดเชย
        </button>
        <button
          type="button"
          id="compensation-summary-tab-compensation"
          class="compensation-summary-tab"
          role="tab"
          aria-controls="compensation-summary-panel-compensation"
          [attr.aria-selected]="activeTab() === 'compensation'"
          [class.active]="activeTab() === 'compensation'"
          (click)="onTabChange('compensation')"
        >
          สรุปค่าสอนเกินภาระงาน
        </button>
      </div>

      <ng-template #comparisonIndexTemplate let-row="row">
        {{ row.sequence }}
      </ng-template>

      <ng-template #comparisonSystemRequestTemplate let-row="row">
        <ng-container *ngIf="row.systemRequest as request; else emptyComparisonCell">
          <div class="compensation-summary-request-line">
            <strong class="compensation-summary-request-title">{{ formatRequestTitle(request) }}</strong>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonErpRequestTemplate let-row="row">
        <ng-container *ngIf="row.erpRequest as erpRequest; else emptyComparisonCell">
          <div class="compensation-summary-request-line">
            <strong>{{ formatErpLeaveDate(row) }}</strong>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #comparisonLeaveDateTemplate let-row="row">
        <span class="compensation-summary-comparison-date">{{ formatLeaveDate(row) }}</span>
      </ng-template>

      <ng-template #comparisonMakeupTeachingTemplate let-row="row">
        <span class="compensation-summary-makeup-date-time">
          <span>{{ formatMakeupTeachingDate(row) }}</span>
          <span class="compensation-summary-makeup-time">
            {{ formatMakeupTeachingTimeWithHours(row) }}
          </span>
        </span>
      </ng-template>

      <ng-template #comparisonStatusTemplate let-row="row">
        <span
          class="compensation-summary-comparison-badge"
          [ngClass]="getComparisonBadgeClass(row.comparisonStatus)"
        >
          {{ row.comparisonLabel }}
        </span>
      </ng-template>

      <ng-template #courseLevelTemplate let-row="row">
        <span class="compensation-summary-course-level">
          {{ row.level }}
        </span>
      </ng-template>

      <ng-template #courseSubjectCodeTemplate let-row="row">
        <ng-container *ngIf="row.rowType === 'total'; else courseSubjectDetail">
          <span class="compensation-summary-course-total-label">รวมทั้งหมด</span>
        </ng-container>
        <ng-template #courseSubjectDetail>
          <span class="compensation-summary-course-code">
            {{ row.subjectCode }}
          </span>
        </ng-template>
      </ng-template>

      <ng-template #courseSubjectNameTemplate let-row="row">
        <span class="compensation-summary-course-name" *ngIf="row.rowType !== 'total'">
          {{ row.subjectName }}
        </span>
      </ng-template>

      <ng-template #courseStudentCountTemplate let-row="row">
        {{ formatStudents(row.studentCount) }}
      </ng-template>

      <ng-template #courseNumberTemplate let-value="value">
        {{ formatTableNumber(value) }}
      </ng-template>

      <ng-template #coursePayableHoursTemplate let-row="row">
        <span class="compensation-summary-course-positive">
          {{ formatTableNumber(row.payableHours) }}
        </span>
      </ng-template>

      <ng-template #courseRateTemplate let-row="row">
        {{ formatRate(row.rateLabel) }}
      </ng-template>

      <ng-template #courseCompensationAmountTemplate let-row="row">
        <span class="compensation-summary-course-positive">
          {{ formatCurrency(row.compensationAmount) }}
        </span>
      </ng-template>

      <div
        id="compensation-summary-panel-compensation"
        class="compensation-summary-tab-panel"
        role="tabpanel"
        aria-labelledby="compensation-summary-tab-compensation"
        *ngIf="activeTab() === 'compensation'"
      >
        <section class="compensation-summary-overview-section" [attr.aria-busy]="isLoading()">
          <div class="compensation-summary-section-header compensation-summary-overview-header">
            <div>
              <h6>สรุปภาพรวม</h6>
              <p class="compensation-summary-section-description">
                คำนวณจากภาระงานสอนทั้งหมด
              </p>
            </div>
            <div class="compensation-summary-erp-imported-at">
              วันที่อัปเดตล่าสุด: {{ formatDateTime(summary().erp_comparison.imported_at) }}
            </div>
          </div>

          <div class="compensation-summary-calculation" aria-label="สรุปการคำนวณค่าชดเชย">
            <div class="compensation-summary-calculation-card compensation-summary-calculation-card-main">
              <div class="compensation-summary-calculation-card-header">
                <span class="compensation-summary-calculation-step">1</span>
                <div>
                  <span class="compensation-summary-calculation-title">คำนวณชั่วโมงสอนที่นับได้</span>
                  <span class="compensation-summary-calculation-description">
                    รวมชั่วโมงจากตารางสอนและคำขอสอนชดเชยที่รับรองแล้ว
                  </span>
                </div>
              </div>

              <div class="compensation-summary-equation">
                <div class="compensation-summary-equation-term">
                  <span>สอนตามตาราง</span>
                  <strong>{{ formatHours(summary().teaching_workload) }}</strong>
                </div>
                <span class="compensation-summary-equation-operator" aria-hidden="true">+</span>
                <div class="compensation-summary-equation-term">
                  <span>สอนชดเชย</span>
                  <strong>{{ formatHours(summary().makeup_teaching_workload) }}</strong>
                </div>
                <span class="compensation-summary-equation-operator" aria-hidden="true">=</span>
                <div class="compensation-summary-equation-term compensation-summary-equation-term-total">
                  <span>รวมสอนทั้งหมด</span>
                  <strong>{{ formatHours(summary().total_teaching_workload) }}</strong>
                </div>
              </div>
            </div>

            <div class="compensation-summary-calculation-card compensation-summary-calculation-card-threshold">
              <div class="compensation-summary-calculation-card-header">
                <span class="compensation-summary-calculation-step">2</span>
                <div>
                  <span class="compensation-summary-calculation-title">เทียบกับภาระงานขั้นต่ำ</span>
                  <span class="compensation-summary-calculation-description">
                    ต้องเกินเกณฑ์นี้ก่อนจึงคิดเป็นชั่วโมงเบิกค่าตอบแทน
                  </span>
                </div>
              </div>

              <div class="compensation-summary-threshold-value">
                <span>ภาระงานขั้นต่ำ</span>
                <strong>{{ formatHours(summary().minimum_teaching_workload) }}</strong>
              </div>
            </div>

            <div class="compensation-summary-calculation-card compensation-summary-calculation-card-result">
              <div class="compensation-summary-calculation-card-header">
                <span class="compensation-summary-calculation-step">3</span>
                <div>
                  <span class="compensation-summary-calculation-title">ผลลัพธ์ที่ใช้เบิก</span>
                  <span class="compensation-summary-calculation-description">
                    ชั่วโมงเกินภาระงานและค่าตอบแทนรวมจากข้อมูลปัจจุบัน
                  </span>
                </div>
              </div>

              <div class="compensation-summary-result-grid">
                <div class="compensation-summary-result-item">
                  <span>ชั่วโมงเกินภาระงาน</span>
                  <strong>{{ formatHours(summary().excess_hours) }}</strong>
                  <small>ส่วนที่เกินจากภาระงานขั้นต่ำ</small>
                </div>
                <div class="compensation-summary-result-item">
                  <span>ค่าตอบแทนรวม</span>
                  <strong>{{ formatCurrency(0) }} บาท</strong>
                  <small>รอเชื่อมต่อสูตรคำนวณค่าตอบแทน</small>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="compensation-summary-course-section">
          <div
            class="compensation-summary-course-tabs"
            role="tablist"
            aria-label="เลือกหลักสูตรสำหรับตารางสรุปค่าสอนเกินภาระงาน"
          >
            <button
              type="button"
              id="compensation-summary-course-tab-regular"
              class="compensation-summary-course-tab"
              role="tab"
              aria-controls="compensation-summary-course-panel"
              [attr.aria-selected]="activeCourseSummaryTab() === 'regular'"
              [class.active]="activeCourseSummaryTab() === 'regular'"
              (click)="onCourseSummaryTabChange('regular')"
            >
              <span class="compensation-summary-course-tab-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <path d="M5.75 4.5h4.1c1.18 0 2.15.96 2.15 2.15V19c0-1.18-.97-2.15-2.15-2.15h-4.1A1.75 1.75 0 0 1 4 15.1V6.25c0-.97.78-1.75 1.75-1.75Z" />
                  <path d="M18.25 4.5h-4.1A2.15 2.15 0 0 0 12 6.65V19c0-1.18.97-2.15 2.15-2.15h4.1A1.75 1.75 0 0 0 20 15.1V6.25c0-.97-.78-1.75-1.75-1.75Z" />
                </svg>
              </span>
              หลักสูตรปกติ
            </button>
            <button
              type="button"
              id="compensation-summary-course-tab-international"
              class="compensation-summary-course-tab"
              role="tab"
              aria-controls="compensation-summary-course-panel"
              [attr.aria-selected]="activeCourseSummaryTab() === 'international'"
              [class.active]="activeCourseSummaryTab() === 'international'"
              (click)="onCourseSummaryTabChange('international')"
            >
              <span class="compensation-summary-course-tab-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false">
                  <circle cx="12" cy="12" r="8.5" />
                  <path d="M3.8 12h16.4" />
                  <path d="M12 3.5c2.15 2.32 3.22 5.15 3.22 8.5S14.15 18.18 12 20.5C9.85 18.18 8.78 15.35 8.78 12S9.85 5.82 12 3.5Z" />
                </svg>
              </span>
              หลักสูตรอินเตอร์
            </button>
          </div>

          <div
            id="compensation-summary-course-panel"
            class="compensation-summary-course-panel"
            role="tabpanel"
            [attr.aria-labelledby]="activeCourseSummaryTab() === 'regular'
              ? 'compensation-summary-course-tab-regular'
              : 'compensation-summary-course-tab-international'"
          >
            <div class="compensation-summary-course-header">
              <div>
                <h6>
                  {{ getCourseSummaryTitle() }}
                  <span>({{ getCourseSummaryDescription() }})</span>
                </h6>
              </div>
              <div class="compensation-summary-course-actions">
              
                <button
                  type="button"
                  class="compensation-summary-export-button"
                  aria-disabled="true"
                >
                  <span class="compensation-summary-export-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" focusable="false">
                      <path d="M14 3.5H7.25A1.75 1.75 0 0 0 5.5 5.25v13.5c0 .97.78 1.75 1.75 1.75h9.5c.97 0 1.75-.78 1.75-1.75V8l-4.5-4.5Z" />
                      <path d="M14 3.5V8h4.5" />
                      <path d="M9 13h6" />
                      <path d="M9 16h4" />
                    </svg>
                  </span>
                  Export PDF
                </button>
              </div>
            </div>

            <div class="compensation-summary-course-table-scroll">
              <app-datatable
                class="compensation-summary-course-datatable"
                [datasource]="courseSummaryTableDatasource"
                [columns]="courseSummaryColumns"
                [isLoading]="false"
                [limit]="courseSummaryTableDatasource.limit"
                [showOrder]="false"
                [externalSorting]="false"
                [maxVisibleRows]="5"
              ></app-datatable>
            </div>
          </div>
        </section>
      </div>

      <div
        id="compensation-summary-panel-requests"
        class="compensation-summary-tab-panel"
        role="tabpanel"
        aria-labelledby="compensation-summary-tab-requests"
        *ngIf="activeTab() === 'requests'"
      >
        <section class="compensation-summary-erp-section">
          <div class="compensation-summary-section-header">
            <div>
              <h6>{{ getErpComparisonTitle() }}</h6>
            </div>
            <p class="compensation-summary-erp-notice">
              <span class="compensation-summary-erp-notice-icon" aria-hidden="true">!</span>
              {{ erpComparisonDescription }}
            </p>
          </div>

          <div class="compensation-summary-erp-empty" *ngIf="!summary().erp_comparison.has_result">
            ยังไม่มีผลตรวจข้อมูล ERP สำหรับเทอมนี้
          </div>

          <div
            class="compensation-summary-state compensation-summary-state-error"
            *ngIf="summary().erp_comparison.has_result && hasErpComparisonDetailError()"
          >
            ไม่สามารถโหลดรายละเอียดผลตรวจข้อมูล ERP ได้ กรุณาลองใหม่อีกครั้ง
          </div>

          <section
            class="compensation-summary-comparison-section"
            *ngIf="summary().erp_comparison.has_result"
          >
            <div
              class="compensation-summary-comparison-loading"
              *ngIf="!hasErpComparisonDetailError() && isLoadingErpComparisonDetail() && !erpComparisonDetail"
            >
              กำลังโหลดผลการเปรียบเทียบ...
            </div>

            <div
              class="compensation-summary-comparison-scroll"
              *ngIf="erpComparisonDetail"
            >
              <app-datatable
                class="compensation-summary-comparison-datatable"
                [datasource]="comparisonTableDatasource"
                [columns]="comparisonColumns"
                [isLoading]="isLoadingErpComparisonDetail()"
                [limit]="comparisonTableDatasource.limit"
                [showOrder]="false"
                [externalSorting]="true"
                [maxVisibleRows]="5"
                (sortChange)="onComparisonSortChange($event)"
              ></app-datatable>

              <app-table-pagination
                [page]="comparisonTableDatasource.page"
                [limit]="comparisonTableDatasource.limit"
                [total]="comparisonTableDatasource.total"
                [totalPage]="comparisonTableDatasource.total_page"
                [offset]="comparisonTableDatasource.offset"
                [dataLength]="comparisonTableDatasource.data.length"
                [pageSizeOptions]="comparisonPageSizeOptions"
                ariaLabel="compensation summary ERP comparison pagination"
                (pageChange)="onComparisonPageChange($event)"
                (limitChange)="onComparisonLimitChange($event)"
              ></app-table-pagination>
            </div>
          </section>
        </section>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyComparisonCell>
  <span class="compensation-summary-comparison-empty">-</span>
</ng-template>
